module.exports = __webpack_public_path__ + "static/media/alicorn.341d2507.svg";